module.exports = __webpack_public_path__ + "static/img/thumb_1.a887e8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_1.png
// module id = Lex5
// module chunks = 0